// Filename - pages/about.js

import {React} from "react";
import {motion} from "framer-motion";
import '../../assets/css/styles.css';
import ThreeColScrolly from "./components/ThreeColScrolly";
import { FiArrowDown} from "react-icons/fi";

const Home = () => {
    return (
        
        <div className="" >
            <section className="hero " >
                <div className="hero-image"></div>
                <div
                    className="absolute inset-0 z-10 pointer-events-none"
                    style={{
                        background: "linear-gradient(to bottom, transparent 90%, black 100%)",
                    }}
                    >
                </div>
                <section className="landing-content" class="  lg:absolute flex text-white top-0 justify-center items-center h-[70vh] lg:h-screen w-screen flex-col">
                    <motion.div
                        initial={{ opacity: 0, y:20}}
                        animate={{ opacity: 1, y:0}}
                        transition={{ duration: 0.8 }}
                    >
                        <h1 class="mx-5 mb-5 text-5xl lg:text-6xl font-bold ">
                            Joshua Law                
                        </h1>
                    </motion.div>
                    <motion.p
                        initial={{ opacity: 0, y:20}}
                        animate={{ opacity: 1, y:0}}
                        transition={{ duration: 1 }}
                        class="mx-5 text-lg lg:text-2xl mb-7"
                    >
                        Software Engineer | Web Designer | Game Development
                    </motion.p>

                    <motion.a
                        href="#Columns"
                        className="border-2  rounded-full text-white p-4  hover:text-violet-500 hover:border-violet-500 transition-colors  hover:border-4 duration-300 ease-in-out box-sizing"
                        initial={{ opacity: 0, y:20}}
                        animate={{ 
                            opacity: 1, y:0,
                            transition: { duration: 1.2 }
                        }}
                        
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.8 }}
                    >
                    <FiArrowDown className="text-4xl" />
                    </motion.a>

                    </section>
            </section>     
            <section id="Columns">
            <ThreeColScrolly/>
            </section>

    
        </div>
    );
};



export default Home;
